export default {
  // Parking Fee Management Page
  'pages.parking-fee.title': 'Parking Fee',
  'pages.parking-fee.subtitle': 'Manage community parking fee bill generation, payment and inquiry',
  'pages.parking-fee.currentSelection': 'Current Selection:',
  'pages.parking-fee.batchCreate': 'Batch Create',
  'pages.parking-fee.tabOther': 'Other',
  'pages.parking-fee.treeTitle': 'Building Floor House Selection',
  'pages.parking-fee.batchCreateModal.title': 'Batch Create Parking Fee Bills',
  'pages.parking-fee.batchCreateModal.confirm': 'Confirm Create',
  'pages.parking-fee.batchCreateModal.cancel': 'Cancel',
  'pages.parking-fee.batchCreateModal.selectPeriod': 'Select Period:',
  'pages.parking-fee.batchCreateModal.periodPlaceholder': 'Please select period',
  'pages.parking-fee.batchCreateModal.confirmTitle': 'Confirm Batch Create',
  'pages.parking-fee.batchCreateModal.confirmContent': 'Are you sure you want to batch create parking fee bills for {period}?',
  'pages.parking-fee.batchCreateModal.success': 'Successfully created {count} bills',
  'pages.parking-fee.batchCreateModal.failed': 'Batch create failed',
  'pages.parking-fee.batchCreateModal.retry': 'Batch create failed, please try again',
  'pages.parking-fee.batchCreateModal.selectPeriodWarning': 'Please select period',
  'pages.parking-fee.batchCreateModal.hint': '💡 Hint: Batch creation will create parking fee bills for the specified period for all houses that have not yet generated bills',
  'pages.parking-fee.batchCreateModal.hint2': 'Existing bills will not be duplicated',

  // Parking Fee Table Page
  'pages.parking-fee.table.title': 'Parking Fee Bills List',
  'pages.parking-fee.table.create': 'Create Bill',
  'pages.parking-fee.table.submitAudit': 'Submit for Audit',
  'pages.parking-fee.table.batchDelete': 'Batch Delete',
  'pages.parking-fee.table.confirmDelete': 'Are you sure you want to delete this record?',
  'pages.parking-fee.table.confirmDeleteSelected': 'Are you sure you want to delete the selected {count} records?',
  'pages.parking-fee.table.deleteSuccess': 'Delete successful',
  'pages.parking-fee.table.deleteFailed': 'Delete failed',
  'pages.parking-fee.table.batchDeleteSuccess': 'Batch delete successful',
  'pages.parking-fee.table.batchDeleteFailed': 'Batch delete failed',
  'pages.parking-fee.table.selectWarning': 'Please select records to delete',
  'pages.parking-fee.table.selectAuditWarning': 'Please select bills to submit for audit',
  'pages.parking-fee.table.submitAuditSuccess': 'Submit for audit successful',
  'pages.parking-fee.table.submitAuditFailed': 'Submit for audit failed',
  'pages.parking-fee.table.auditNamePlaceholder': 'Please enter audit name',
  'pages.parking-fee.table.auditNameRequired': 'Please enter audit name',
  'pages.parking-fee.table.submitRemarkPlaceholder': 'Please enter submission notes (optional)',
  'pages.parking-fee.table.selectedBillsTitle': 'Selected Bills List (Total {count})',

  // Table Column Titles
  'pages.parking-fee.table.columns.houseNumber': 'House Number',
  'pages.parking-fee.table.columns.parkingInfo': 'Parking Info',
  'pages.parking-fee.table.columns.period': 'Period',
  'pages.parking-fee.table.columns.billNumber': 'Bill Number',
  'pages.parking-fee.table.columns.ownerPhone': 'Owner Phone',
  'pages.parking-fee.table.columns.ownerIdCard': 'Owner ID Card',
  'pages.parking-fee.table.columns.ownerEmail': 'Owner Email',
  'pages.parking-fee.table.columns.finalAmount': 'Final Amount Due',
  'pages.parking-fee.table.columns.auditStatus': 'Audit Status',
  'pages.parking-fee.table.columns.paymentStatus': 'Payment Status',
  'pages.parking-fee.table.columns.paymentTime': 'Payment Time',
  'pages.parking-fee.table.columns.dueDate': 'Due Date',
  'pages.parking-fee.table.columns.operations': 'Operations',
  'pages.parking-fee.table.columns.totalAmount': 'Total Amount',

  // Action Buttons
  'pages.parking-fee.table.actions.view': 'View',
  'pages.parking-fee.table.actions.edit': 'Edit',
  'pages.parking-fee.table.actions.delete': 'Delete',
  'pages.parking-fee.table.actions.confirm': 'Confirm',
  'pages.parking-fee.table.actions.cancel': 'Cancel',

  // Audit Status
  'pages.parking-fee.table.auditStatus.draft': 'Draft',
  'pages.parking-fee.table.auditStatus.pending': 'Pending',
  'pages.parking-fee.table.auditStatus.approved': 'Approved',
  'pages.parking-fee.table.auditStatus.rejected': 'Rejected',
  'pages.parking-fee.table.auditStatus.notified': 'Notified',
  'pages.parking-fee.table.auditStatus.overdue': 'Overdue',
  'pages.parking-fee.table.auditStatus.cancelled': 'Cancelled',

  // Payment Status
  'pages.parking-fee.table.paymentStatus.unpaid': 'Unpaid',
  'pages.parking-fee.table.paymentStatus.paid': 'Paid',
  'pages.parking-fee.table.paymentStatus.overdue': 'Overdue',
  'pages.parking-fee.table.paymentStatus.partial': 'Partial Payment',
  'pages.parking-fee.table.paymentStatus.cancelled': 'Cancelled',

  // Detail Modal
  'pages.parking-fee.table.detail.title': 'Parking Fee Bill Details',
  'pages.parking-fee.table.detail.close': 'Close',
  'pages.parking-fee.table.detail.basicInfo': 'Basic Information',
  'pages.parking-fee.table.detail.parkingOwnerInfo': 'Parking & Owner Information',
  'pages.parking-fee.table.detail.amountInfo': 'Amount Information',
  'pages.parking-fee.table.detail.paymentInfo': 'Payment Information',
  'pages.parking-fee.table.detail.systemInfo': 'System Information',
  'pages.parking-fee.table.detail.auditRecords': 'Audit Records',
  'pages.parking-fee.table.detail.loading': 'Loading...',
  'pages.parking-fee.table.detail.noRecords': 'No audit records',

  // ParkingFeeForm Form
  'pages.parking-fee.form.editTitle': 'Edit Parking Fee Bill',
  'pages.parking-fee.form.createTitle': 'Create Parking Fee Bill',
  'pages.parking-fee.form.basicInfo': 'Basic Information',
  'pages.parking-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.parking-fee.form.feeInfo': 'Fee Information',
  'pages.parking-fee.form.remarks': 'Remarks',

  // Form Field Labels
  'pages.parking-fee.form.fields.billNo': 'Bill Number',
  'pages.parking-fee.form.fields.status': 'Payment Status',
  'pages.parking-fee.form.fields.period': 'Period',
  'pages.parking-fee.form.fields.startDate': 'Start Date',
  'pages.parking-fee.form.fields.endDate': 'End Date',
  'pages.parking-fee.form.fields.building': 'Building',
  'pages.parking-fee.form.fields.floor': 'Floor',
  'pages.parking-fee.form.fields.house': 'House',
  'pages.parking-fee.form.fields.parkingInfo': 'Parking Info',
  'pages.parking-fee.form.fields.parkingFee': 'Parking Fee Amount',
  'pages.parking-fee.form.fields.lateFee': 'Late Fee',
  'pages.parking-fee.form.fields.discountAmount': 'Discount Amount',
  'pages.parking-fee.form.fields.finalAmount': 'Final Amount Due',
  'pages.parking-fee.form.fields.remarks': 'Remarks',

  // Form Validation Messages
  'pages.parking-fee.form.validation.billNoRequired': 'Please enter bill number',
  'pages.parking-fee.form.validation.statusRequired': 'Please select payment status',
  'pages.parking-fee.form.validation.periodRequired': 'Please enter period',
  'pages.parking-fee.form.validation.startDateRequired': 'Please select start date',
  'pages.parking-fee.form.validation.endDateRequired': 'Please select end date',
  'pages.parking-fee.form.validation.buildingRequired': 'Please select building',
  'pages.parking-fee.form.validation.floorRequired': 'Please select floor',
  'pages.parking-fee.form.validation.houseRequired': 'Please select house',
  'pages.parking-fee.form.validation.parkingFeeRequired': 'Please enter parking fee amount',
  'pages.parking-fee.form.validation.finalAmountRequired': 'Final amount will be calculated automatically',
  'pages.parking-fee.form.validation.remarksMaxLength': 'Remarks cannot exceed 500 characters',

  // Form Placeholders
  'pages.parking-fee.form.placeholder.billNo': 'Please enter bill number',
  'pages.parking-fee.form.placeholder.period': 'e.g.: 2024-01',
  'pages.parking-fee.form.placeholder.startDate': 'Please select start date',
  'pages.parking-fee.form.placeholder.endDate': 'Please select end date',
  'pages.parking-fee.form.placeholder.building': 'Please select building',
  'pages.parking-fee.form.placeholder.floor': 'Please select floor',
  'pages.parking-fee.form.placeholder.house': 'Please select house',
  'pages.parking-fee.form.placeholder.parkingFee': 'Please enter parking fee amount',
  'pages.parking-fee.form.placeholder.lateFee': 'Please enter late fee',
  'pages.parking-fee.form.placeholder.discountAmount': 'Please enter discount amount',
  'pages.parking-fee.form.placeholder.finalAmount': 'Auto calculate',
  'pages.parking-fee.form.placeholder.remarks': 'Please enter remarks',

  // Form Messages and Errors
  'pages.parking-fee.form.message.houseNotOpenService': 'This house has not opened parking fee service',
  'pages.parking-fee.form.message.loadConfigFailed': 'Failed to load parking fee configuration',
  'pages.parking-fee.form.message.houseNotBindParking': 'This house is not bound to a parking space',
  'pages.parking-fee.form.message.parkingInfoNotFound': 'Unable to find parking information for this house',
  'pages.parking-fee.form.message.updateSuccess': 'Update successful',
  'pages.parking-fee.form.message.createSuccess': 'Create successful',

  // Detail Modal Labels
  'pages.parking-fee.table.detail.labels.billNo': 'Bill Number',
  'pages.parking-fee.table.detail.labels.period': 'Period',
  'pages.parking-fee.table.detail.labels.paymentStatus': 'Payment Status',
  'pages.parking-fee.table.detail.labels.auditStatus': 'Audit Status',
  'pages.parking-fee.table.detail.labels.startDate': 'Start Date',
  'pages.parking-fee.table.detail.labels.endDate': 'End Date',
  'pages.parking-fee.table.detail.labels.parkingInfo': 'Parking Info',
  'pages.parking-fee.table.detail.labels.ownerInfo': 'Owner Info',
  'pages.parking-fee.table.detail.labels.parkingFee': 'Parking Fee Amount',
  'pages.parking-fee.table.detail.labels.lateFee': 'Late Fee',
  'pages.parking-fee.table.detail.labels.discountAmount': 'Discount Amount',
  'pages.parking-fee.table.detail.labels.finalAmount': 'Final Amount',
  'pages.parking-fee.table.detail.labels.paymentMethod': 'Payment Method',
  'pages.parking-fee.table.detail.labels.paymentReference': 'Payment Receipt Number',
  'pages.parking-fee.table.detail.labels.paymentDate': 'Payment Date',
  'pages.parking-fee.table.detail.labels.createTime': 'Create Time',
  'pages.parking-fee.table.detail.labels.updateTime': 'Update Time',
  'pages.parking-fee.table.detail.labels.remark': 'Remark',
  'pages.parking-fee.table.detail.labels.ownerId': 'Owner ID',
  'pages.parking-fee.table.detail.labels.idCard': 'ID Card',
  'pages.parking-fee.table.detail.labels.email': 'Email',

  // Submit Audit Modal
  'pages.parking-fee.table.auditModal.title': 'Submit for Audit',
  'pages.parking-fee.table.auditModal.submit': 'Submit for Audit',
  'pages.parking-fee.table.auditModal.auditName': 'Audit Name',
  'pages.parking-fee.table.auditModal.submitRemark': 'Submission Notes',

  // Submit Audit Modal Table Column Titles
  'pages.parking-fee.table.auditModal.columns.billNo': 'Bill Number',
  'pages.parking-fee.table.auditModal.columns.parkingInfo': 'Parking Info',
  'pages.parking-fee.table.auditModal.columns.period': 'Period',
  'pages.parking-fee.table.auditModal.columns.totalAmount': 'Total Amount',
  'pages.parking-fee.table.auditModal.columns.paymentStatus': 'Payment Status',

  // Breadcrumb Navigation
  'pages.breadcrumb.chargeManagement': 'Charge Management',
  'pages.breadcrumb.parkingFee': 'Parking Fee',

  // Currency Units
  'pages.parking-fee.currency.php': '₱',

  // Detail Component Fields
  'pages.parking-fee.detail.basicInfo': 'Basic Information',
  'pages.parking-fee.detail.billNo': 'Bill Number',
  'pages.parking-fee.detail.period': 'Period',
  'pages.parking-fee.detail.paymentStatus': 'Payment Status',
  'pages.parking-fee.detail.approvalStatus': 'Approval Status',
  'pages.parking-fee.detail.startDate': 'Start Date',
  'pages.parking-fee.detail.endDate': 'End Date',
  'pages.parking-fee.detail.parkingOwnerInfo': 'Parking & Owner Information',
  'pages.parking-fee.detail.parkingInfo': 'Parking Information',
  'pages.parking-fee.detail.houseInfo': 'Related House',
  'pages.parking-fee.detail.ownerInfo': 'Owner Information',
  'pages.parking-fee.detail.amountInfo': 'Amount Information',
  'pages.parking-fee.detail.baseAmount': 'Base Amount',
  'pages.parking-fee.detail.lateFee': 'Late Fee',
  'pages.parking-fee.detail.discountAmount': 'Discount Amount',
  'pages.parking-fee.detail.finalAmount': 'Final Amount',
  'pages.parking-fee.detail.paymentInfo': 'Payment Information',
  'pages.parking-fee.detail.paymentMethod': 'Payment Method',
  'pages.parking-fee.detail.paymentReference': 'Payment Reference',
  'pages.parking-fee.detail.dueDate': 'Due Date',
  'pages.parking-fee.detail.paymentDate': 'Payment Date',
  'pages.parking-fee.detail.systemInfo': 'System Information',
  'pages.parking-fee.detail.createdTime': 'Created Time',
  'pages.parking-fee.detail.updatedTime': 'Updated Time',
  'pages.parking-fee.detail.remarks': 'Remarks',
};
